import logger from '@widgets/logger';
import { KB, MB, MEDIA_TYPE } from '@constants/file';

export const formatVideoSize = bytes =>
    bytes >= 1000 * MB
        ? `${bytes / (1000 * MB)} GB`
        : bytes >= MB
          ? `${Math.round(bytes / MB)} MB`
          : `${Math.round(bytes / KB)} KB`;

export const formatVideoDuration = seconds => {
    if (seconds < 60) return `${seconds} s`;
    if (seconds % 60 === 0) return `${seconds / 60} min`;
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')} min`;
};

export const validateFileSize = (file, max, min) => {
    let error = '';
    let metric = '';
    let size = '';
    if (max && file?.size > max) {
        error = 'file_size_too_large';
        metric = max > MB ? 'MB' : 'KB';
        size = max > MB ? max / MB : max / KB;
    }
    if (min && file?.size < min) {
        error = 'file_size_too_small';
        metric = min > MB ? 'MB' : 'KB';
        size = min > MB ? min / MB : min / KB;
    }
    return { error, metric, size };
};

export const validateFileParams = async (
    mediaType,
    objUrl,
    params = { dimension: [], minDuration: undefined, maxDuration: undefined },
    callback,
) => {
    const { dimension, minDuration, maxDuration } = params;
    const [minWidth, minHeight, maxWidth, maxHeight] = dimension;
    try {
        const media = await (mediaType === MEDIA_TYPE.IMAGE ? loadImage(objUrl) : loadVideo(objUrl));
        const prop = mediaType === MEDIA_TYPE.IMAGE ? ['width', 'height'] : ['videoWidth', 'videoHeight'];
        const width = media[prop[0]];
        const height = media[prop[1]];
        const isHorizontal = width >= height;

        const belowMin = (minWidth && width < minWidth) || (minHeight && height < minHeight);
        const aboveMax =
            (maxWidth &&
                maxHeight &&
                ((isHorizontal && (width > maxWidth || height > maxHeight)) ||
                    (!isHorizontal && (height > maxWidth || width > maxHeight)))) ||
            (maxWidth && !maxHeight && width > maxWidth) ||
            (maxHeight && !maxWidth && height > maxHeight);

        if (belowMin || aboveMax) {
            callback(belowMin ? 'min-dimension' : 'max-dimension');
            return { success: false };
        } else if ((minDuration && media.duration < minDuration) || (maxDuration && media.duration > maxDuration)) {
            callback('duration');
            return { success: false };
        }
        return { success: true, width, height, duration: media.duration };
    } catch (_) {
        logger.error("Couldn't upload media");
        // Without this the caller skips the file silently.
        callback('load-failure');
        return { success: false };
    }
};

const loadImage = path => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = path;
        img.onload = () => resolve(img);
        img.onerror = e => reject(e);
    });
};

const loadVideo = path => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = path;
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
            resolve(video);
        };

        video.onerror = e => reject(e);
    });
};
